import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CountdownTimer from '../_components/CountDownTimer';
import { Path } from '../_components/Path';
import { examService } from '../_services/exam.service';
import { isEnglish } from '../_helpers';
import { MockTestSingle } from './MockTestSingle';
import { Overview } from './Overview';

export const MockTest = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { mockTest, attempt } = location.state;

  const [query, setQuery] = useState({
    pageVo: {
      pageNo: 1,
      noOfItems: 100,
    },
  });
  const [isLoading, setIsLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [mockEnd, setMockEnd] = useState(false);
  console.log(isLoading, 'renderingg====', 'Questions===', mockEnd);

  useEffect(() => {
    if (mockTest) {
      getQuestionAnswerWithPrevNext({
        mocktest_id: mockTest?._id,
      });
    }
  }, [mockTest]);

  useEffect(() => {
    if (mockEnd) {
      navigate('/examresult', { state: { topicData: mockTest, mode: 3, attempt } });
    }
  }, [mockEnd]);

  function getQuestionAnswerWithPrevNext(queryTemp) {
    let queryNew = queryTemp ? queryTemp : query;
    // queryNew.mocktest_id = mocktest_id;

    setQuery(queryNew);
    queryNew.mode = 3;
    queryNew.attempt = attempt ? attempt : 1;
    examService.getQuestionAnswerWithPrevNextforMockTest(queryNew).then(
      (res) => {
        // if (res.data == 0) {
        //   navigate('/examresult', { state: { topicData: mockTest, mode: 3 } });
        // }
        if (res.data) {
          setIsLoading(false);
          setQuestions(res.data);
        } else {
          setIsLoading(false);
          setQuestions({});
        }
      },
      (err) => {
        setIsLoading(false);
        console.error('error from getQuestionAnswerWithPrevNext', err);
      },
    );
  }

  const handleNext = (nextId, order, currentId) => {
    if (questions.answer && questions.index + 1 == questions.length) {
      navigate('/examresult', { state: { topicData: mockTest, mode: 3, attempt } });
    }
    getQuestionAnswerWithPrevNext({
      question_id: nextId,
      mocktest_id: mockTest?._id,
      isNext: true,
      currentOrder: order,
      currentQuesId: currentId,
    });
  };
  const handlePrev = (prevId, order, currentId) => {
    getQuestionAnswerWithPrevNext({
      question_id: prevId,
      mocktest_id: mockTest?._id,
      isPrev: true,
      currentOrder: order,
      currentQuesId: currentId,
    });
  };

  return (
    <div className='exam'>
      {!isLoading && (
        <div className='container'>
          <Path pathList={[{ name: 'Mock Test' }]} />
          {mockTest?.mocktest_name && (
            <div
              className={
                'topicname ' + (isEnglish(mockTest?.mocktest_name) ? 'ltrtext' : 'rtltext')
              }
            >
              {mockTest?.mocktest_name}
            </div>
          )}
          {mockTest?._id && (
            <div
              className={
                'd-flex gap-2 ' +
                (isEnglish(mockTest?.mocktest_name) ? 'justify-content-start' : 'justify-content-end')
              }
            >
              <div className='descitem'>
                <img src='/img/question_icon.png' className='desc_icon' /> {mockTest?.mocktestcount}{' '}
                Questions
              </div>

              <div className='examlabel testlbl'>Mock Test</div>
            </div>
          )}
          <CountdownTimer
            durationInSeconds={mockTest?.time_duration ? mockTest?.time_duration : 3600}
            // durationInSeconds={120}
            setMockEnd={setMockEnd}
          />
          <div className='d-flex flex-wrap'>
            <MockTestSingle
              question={questions}
              totalQuestions={questions?.length}
              handleNext={handleNext}
              handlePrev={handlePrev}
              attempt={attempt}
            />
            <Overview QnLength={questions?.length} item={questions} />
          </div>
        </div>
      )}
    </div>
  );
};
